// extracted by mini-css-extract-plugin
export var text = "_3w-0";